import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Input } from '../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { ServiceCard } from '../components/Cards';

export default function ServicesPage() {
  const { t, i18n } = useTranslation();
  const { services, fetchServices } = useAppStore();
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ city: '', service_type: 'all' });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = { ...filters };
      if (params.service_type === 'all') delete params.service_type;
      await fetchServices(params);
      setLoading(false);
    };
    load();
  }, [fetchServices, filters]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 animate-fade-in" data-testid="services-page">
      <h1 className="font-serif text-4xl font-bold text-primary mb-8">{t('service.title')}</h1>
      
      <div className="flex flex-wrap gap-4 mb-8">
        <Input
          placeholder={t('filters.locationPlaceholder')}
          value={filters.city}
          onChange={(e) => setFilters({ ...filters, city: e.target.value })}
          className="w-48"
          data-testid="filter-city"
        />
        <Select value={filters.service_type} onValueChange={(v) => setFilters({ ...filters, service_type: v })}>
          <SelectTrigger className="w-48" data-testid="filter-type">
            <SelectValue placeholder={t('service.type')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t('common.all')}</SelectItem>
            <SelectItem value="tantric_massage">{t('service.types.tantric_massage')}</SelectItem>
            <SelectItem value="tantra_coaching">{t('service.types.tantra_coaching')}</SelectItem>
            <SelectItem value="couple_session">{t('service.types.couple_session')}</SelectItem>
            <SelectItem value="tantra_therapy">{t('service.types.tantra_therapy')}</SelectItem>
            <SelectItem value="tantra_initiation">{t('service.types.tantra_initiation')}</SelectItem>
            <SelectItem value="esta_training">{t('service.types.esta_training')}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.loading')}</p></div>
      ) : services.length === 0 ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.noResults')}</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} language={i18n.language} />
          ))}
        </div>
      )}
    </div>
  );
}
